import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { DBCollectionName } from '../enums';
import { Users } from '../models';

@Injectable({ providedIn: 'root' })
export class UsersService extends BaseService<Users> {
  constructor(angularFirestore: AngularFirestore) {
    super(DBCollectionName.USERS, angularFirestore);
  }
}
